import { useEffect, useRef } from 'react';
import type { FreeChat } from '@orborix/voice-composer';
import type { AssistedPhase } from './useAssistedTurn.js';

/**
 * Cuándo la charla asistida deja de escuchar en manos libres:
 *  - con la oferta de hacerlo solo a la vista, la charla queda en pausa hasta
 *    que el alumno decide (Emmanuel, 14/10: el cartel no le impedía seguir
 *    hablando y la charla seguía de fondo);
 *  - después de un intento que no salió, hasta que toca «Decila una vez más»
 *    (Emmanuel, 16/10: con el micrófono abierto, lo que decía mientras leía la
 *    tarjeta —«Latte», «Okay», la frase empezada por la mitad— contaba como
 *    otro intento, y salía mal).
 */
export function assistedMicPaused(phase: AssistedPhase): boolean {
  return phase === 'offer' || phase === 'rejected';
}

/**
 * En manos libres, silencia el micrófono mientras `paused` —la barra lo
 * muestra— y al soltarlo vuelve como estaba: si ya lo tenía silenciado, queda
 * así. Con el botón de mantener, la oferta apaga el composer aparte
 * (`disabled`), y después de un intento mal el micrófono ya está cerrado.
 */
export function useAssistedMicPause(paused: boolean, freeChat: FreeChat): void {
  const mutedByUs = useRef(false);
  const freeChatRef = useRef(freeChat);
  freeChatRef.current = freeChat;
  useEffect(() => {
    const fc = freeChatRef.current;
    if (paused) {
      if (fc.active && !fc.muted) {
        fc.toggleMute();
        mutedByUs.current = true;
      }
    } else if (mutedByUs.current) {
      mutedByUs.current = false;
      if (fc.active && fc.muted) fc.toggleMute();
    }
  }, [paused]);
}
